import { getItemFromCollection } from "directus/src/operations";

export async function fetchGradeData({ gradeId }) {
  try {
    const response = await getItemFromCollection("grades", gradeId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
